/**
 * Everpret CheckoutManager
 *
 * Provider-agnostic checkout entry point: checkoutManager.checkout(cart).
 * Today the only provider is Shopify Native Checkout — GoKwik is explicitly
 * NOT implemented in this build. Swapping in a GoKwik provider later is a
 * one-line change here; nothing in CartStore/RewardSynchronizer/RecommendationEngine
 * needs to change.
 *
 * Also where the checkout race condition is closed: it waits for any pending
 * reward synchronization to finish before letting the native checkout
 * navigation proceed, so a customer can never check out mid-sync. It never
 * intercepts or replaces the native navigation itself — Shopify's own
 * Web Pixel / Customer Events (which already fire InitiateCheckout without
 * any theme code, per inspection) keep working unmodified.
 */
(function (window) {
  'use strict';

  var shopifyNativeCheckoutProvider = {
    // formEl.requestSubmit(submitter) — unlike formEl.submit() — preserves the
    // triggering submit button's name/value (the cart form's checkout
    // redirect depends on the "checkout" button's name being present).
    checkout: function (cart, formEl, submitterEl) {
      if (formEl && formEl.requestSubmit) {
        formEl.requestSubmit(submitterEl || undefined);
      } else if (formEl) {
        HTMLFormElement.prototype.submit.call(formEl);
      } else {
        window.location.href = window.Shopify.routes.root.replace(/\/$/, '') + '/checkout';
      }
    },
  };

  function CheckoutManager(rewardSynchronizer, provider) {
    this.rewardSynchronizer = rewardSynchronizer;
    this.provider = provider || shopifyNativeCheckoutProvider;
  }

  /** True only while a reward sync is genuinely in flight — the fast path
   *  (no pending sync) never delays checkout by even one microtask. */
  CheckoutManager.prototype.hasPendingSync = function () {
    return !!(this.rewardSynchronizer && this.rewardSynchronizer._lock);
  };

  /** Resolves once no reward sync is in flight, waiting a short grace period
   *  for one already scheduled, then proceeds — never blocks indefinitely. */
  CheckoutManager.prototype._waitForRewardSync = function () {
    var pending = this.rewardSynchronizer && this.rewardSynchronizer._lock;
    if (!pending) return Promise.resolve();
    return Promise.race([
      pending,
      new Promise(function (resolve) {
        setTimeout(resolve, 2500);
      }),
    ]);
  };

  CheckoutManager.prototype.checkout = function (cart, formEl, submitterEl) {
    var provider = this.provider;
    return this._waitForRewardSync().then(function () {
      provider.checkout(cart, formEl, submitterEl);
    });
  };

  window.Everpret = window.Everpret || {};
  window.Everpret.CheckoutManager = CheckoutManager;
  window.Everpret.shopifyNativeCheckoutProvider = shopifyNativeCheckoutProvider;
})(window);
